import React from "react";

import { Card, CardContent, CardHeader } from "@mui/material";
import { Table, TableRow, TableCell, TableBody, TableHead } from "@mui/material";



import AdministrationParametreRow from './AdministrationParametreRow';

import { ParametreCodes } from 'constants.js';

const parametres = [
    // On permet pas l'édition du PctJokerFraisRetour ici car c'est déjà fait dans l'exclusion des frais de retour
    //{ code: ParametreCodes.PctJokerFraisRetour, description: 'pourcentage "joker" frais de retour', autoriseEdition: false },
    { code: ParametreCodes.SAVMajorationMontant, description: 'Montant de la majoration sur un SAV non Foussier hors-garantie', autoriseEdition: true, autoriseVide: false },
    { code: ParametreCodes.SAVMajorationCodeArticle, description: 'Code article de la majoration sur un SAV non Foussier hors-garantie', autoriseEdition: true, autoriseVide: true },
    { code: ParametreCodes.ShuntGenerationAvoir, description: "Shunt de la génération d'avoir : OUI ou NON", autoriseEdition: true, autoriseVide: true },
    { code: ParametreCodes.ShuntLitigeToDossier, description: "Shunt de la génération automatique des litiges en dossiers : OUI ou NON", autoriseEdition: true, autoriseVide: false },
]


const AdministrationParametres = () => {

    return (
        <Card>
            <CardHeader 
                title={"Administration des paramètres"}
            />
                
            <CardContent>

                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Valeur</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {parametres.map(parametre => {

                            return (
                                <AdministrationParametreRow
                                    key={parametre.code}
                                    code={parametre.code}
                                    description={parametre.description}
                                    autoriseEdition={parametre.autoriseEdition}
                                    autoriseVide={parametre.autoriseVide}
                                />
                            )
                        })}

                    </TableBody>
                </Table>


            </CardContent>

            
        </Card>
        );

}

export default AdministrationParametres;